import "./_story-component-styles.scss";

import './story-component';
